<div class="w-screen h-screen flex justify-center items-center bg-gray-50">
    <div class="text-xl sm:text-4xl text-center tracking-tight leading-tight">
        This link is expired or incorrect
    </div>
</div>
